import React, {useEffect, useState} from 'react';
import cl from './SurveysPage.module.css';
import {Alert, Divider, LinearProgress} from "@mui/material";
import SurveysPageMenuItem from "./SurveysPageMenuItem";
import SurveysBrowseSubPage from "./SurveysBrowseSubPage";
import SurveysSummarySubPage from "./SurveysSummarySubPage";
import ServerManager from "../../API/ServerManager";
import AlertSnackbar from "../../components/AlertSnackbar/AlertSnackbar";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";

const subPages = [
    {title: "Сводка", SubPageComponent: SurveysSummarySubPage},
    {title: "Обзор", SubPageComponent: SurveysBrowseSubPage},
];

const SurveysPage = ({isAddSubMode}) => {

    const [currentSubPage, setCurrentSubPage] = useState(subPages[0]);

    const CurrentSubPageComponent = currentSubPage.SubPageComponent;

    const [isPreLoading, setIsPreLoading] = useState(true)
    const [surveyData, setSurveyData] = useState(null)
    const [preLoadingErrorMessage, setPreLoadingErrorMessage] = useState("")

    useEffect(() => {
        async function fetch() {
            setIsPreLoading(true);
            //setSurveyData(null);
            try {
                //await new Promise(resolve => setTimeout(resolve, 2000)); // temp!
                const data = await ServerManager.getSurvey();
                if (!ignore) {
                    setSurveyData(data);
                }
            } catch (error) {
                if (!ignore) {
                    setPreLoadingErrorMessage(`Ошибка при загрузке данных: ${error}`);
                }
            } finally {
                if (!ignore) setIsPreLoading(false);
            }
        }

        let ignore = false;
        fetch();
        return () => {
            ignore = true;
        }
    }, []);

    // TODO: можно сделать глобальными? обрабатывать в корневом компоненте?
    const [loadingOverlayData, setLoadingOverlayData] = useState(null); // { title }
    const [snackbarData, setSnackbarData] = useState(null); // { severity, title, message }
    const [confirmDialogData, setConfirmDialogData] = useState(null); // { message, confirmLabel, cancelLabel, onAnswer }

    const handleErrorSnackbarClose = (event, reason) => {
        setSnackbarData(null);
    };

    return (
        <div className={cl.main}>
            {isPreLoading && <LinearProgress/>}
            {!isPreLoading && preLoadingErrorMessage &&
                <Alert variant="outlined" severity="error">{preLoadingErrorMessage}</Alert>}
            {!isPreLoading && !preLoadingErrorMessage && <>
                <div className={cl.menu}>
                    {subPages.map(item => (
                        <SurveysPageMenuItem
                            key={item.title}
                            title={item.title}
                            selected={item === currentSubPage}
                            onClick={() => setCurrentSubPage(item)}
                        />
                    ))}
                </div>
                <Divider sx={{margin: "0 10px"}}/>
                <div className={cl.workArea}>
                    <CurrentSubPageComponent isAddSubMode={isAddSubMode} surveyData={surveyData}/>
                </div>
            </>}
            {snackbarData && <AlertSnackbar
                open={true}
                severity={snackbarData.severity}
                title={snackbarData.title}
                message={<div style={{whiteSpace:"pre-line"}}>{snackbarData.message}</div>}
                onClose={handleErrorSnackbarClose}
            />}
            {loadingOverlayData && <LoadingOverlay
                open={true}
                title={loadingOverlayData.title}
            />}
            {confirmDialogData && <ConfirmDialog
                open={true}
                message={confirmDialogData.message}
                confirmLabel={confirmDialogData.confirmLabel}
                cancelLabel={confirmDialogData.cancelLabel}
                onAnswer={confirmDialogData.onAnswer}
            />}
        </div>
    );
};

export default SurveysPage;